module.exports = __webpack_public_path__ + "static/img/arduino_uno-1.599c558.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/arduino_uno-1.svg
// module id = u2FQ
// module chunks = 0